import React, { useEffect, useState } from 'react';
import { Pressable, View } from 'react-native';
import { Flex, Typography, IconClose, ColorValues } from '@banhala/ui-kit';
import { localStorageBridge } from 'shared/src/utils';

const STORAGE_KEY = 'SHOULD_SHOW_SEARCH_CAMERA_SEARCH_TOOLTIP';

export const SearchCameraTooltip = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    (async () => {
      const shouldShow = await localStorageBridge.getBoolean(STORAGE_KEY);
      setVisible(shouldShow ?? true);
    })();
  }, []);

  const hideTooltip = () => {
    localStorageBridge.putBoolean(STORAGE_KEY, false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Pressable onPress={hideTooltip}>
      <Flex alignItems="flex-end">
        <View
          style={{
            width: 10,
            height: 10,
            backgroundColor: ColorValues.gray70,
            transform: [{ rotate: '45deg' }],
            marginRight: 22,
            marginBottom: -5,
            borderTopLeftRadius: 1,
          }}
        />

        <Flex.Row
          backgroundColor="content_primary"
          borderRadius={8}
          padding={{ horizontal: 10, vertical: 10 }}
          alignItems="center"
          width={160}
        >
          <Typography
            type="body4"
            color="content_always_white"
            numberOfLines={2}
          >
            맘에 드는 상품과{'\n'}비슷한 상품을 찾아 보세요
          </Typography>
          <Flex margin={{ left: 6 }}>
            <IconClose fill={ColorValues.white} size={16} />
          </Flex>
        </Flex.Row>
      </Flex>
    </Pressable>
  );
};
